"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStoreProperties = exports.getLocaleProperties = void 0;
var constants_1 = require("../constants");
var cookieUtils_1 = require("./cookieUtils");
var getStoreCode = function () {
    var _a, _b;
    var stores = Object.values(constants_1.STORE);
    // Look for `store` on pathnames that may or may not contain `locale`
    var url = (_a = window.location.pathname.split('/').at(1)) === null || _a === void 0 ? void 0 : _a.split('-').at(0);
    var cookies = [(0, cookieUtils_1.getCookie)('x-grover-store'), (0, cookieUtils_1.getCookie)('shop_country_code')];
    return (_b = stores.find(function (value) { return __spreadArray([url], cookies, true).includes(value); })) !== null && _b !== void 0 ? _b : null;
};
var getLocaleCode = function () {
    var _a, _b;
    var locales = Object.values(constants_1.LOCALE);
    var url = (_a = window.location.pathname.split('/').at(1)) === null || _a === void 0 ? void 0 : _a.split('-').at(1);
    var cookie = (0, cookieUtils_1.getCookie)('locale');
    return (_b = locales.find(function (value) { return [url, cookie].includes(value); })) !== null && _b !== void 0 ? _b : null;
};
var getLocaleProperties = function () {
    var locale = getLocaleCode();
    return {
        locale: locale !== null && locale !== void 0 ? locale : undefined,
    };
};
exports.getLocaleProperties = getLocaleProperties;
var getStoreProperties = function () {
    var _a;
    var store_code = getStoreCode();
    return {
        store: store_code !== null && store_code !== void 0 ? store_code : undefined,
        store_id: (_a = (store_code && constants_1.STORE_ID[store_code])) !== null && _a !== void 0 ? _a : undefined,
    };
};
exports.getStoreProperties = getStoreProperties;
//# sourceMappingURL=localeUtils.js.map